// extracted by mini-css-extract-plugin
export var skipAnimation = "_16-0";